"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const RoutingService = __importStar(require("./RoutingService"));
const turf = __importStar(require("@turf/turf"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const MathUtils_1 = require("../../utils/MathUtils");
//TODO: Add tests
/**
 * This class provides routing services using manual routing. This mode will always return return results
 */
class ManualRoutingService extends RoutingService.default {
    directRouting(nodesAndWaypointsGeojsons_1, defaultRunningSpeedMps_1) {
        return __awaiter(this, arguments, void 0, function* (nodesAndWaypointsGeojsons, defaultRunningSpeedMps, oneLegPerWaypoint = true) {
            const lineString = turf.lineString(nodesAndWaypointsGeojsons.map((geojson) => {
                return geojson.geometry.coordinates;
            }));
            const lineLength = turf.length(lineString, { units: 'meters' });
            if (defaultRunningSpeedMps === undefined || defaultRunningSpeedMps === null || defaultRunningSpeedMps === 0) {
                defaultRunningSpeedMps = 30 / 3.6; // this should not happen!
            }
            const runningSpeed = defaultRunningSpeedMps;
            const birdDistanceDuration = (0, MathUtils_1.ceilToPositiveInteger)(lineLength / runningSpeed);
            const legs = [];
            let legCoordinates = [];
            nodesAndWaypointsGeojsons.forEach((nodeOrWaypoint, pointIndex) => {
                var _a;
                legCoordinates.push(nodeOrWaypoint.geometry.coordinates);
                //console.log('legCoordinates', JSON.parse(JSON.stringify(legCoordinates)));
                if ((oneLegPerWaypoint ||
                    ((_a = nodeOrWaypoint.properties) === null || _a === void 0 ? void 0 : _a.isNode) === true ||
                    pointIndex === nodesAndWaypointsGeojsons.length - 1) &&
                    pointIndex > 0) {
                    const legGeojson = turf.lineString((0, cloneDeep_1.default)(legCoordinates));
                    const legLength = turf.length(legGeojson, { units: 'meters' });
                    legs.push({
                        distance: legLength,
                        duration: (0, MathUtils_1.ceilToPositiveInteger)(legLength / runningSpeed),
                        steps: [
                            {
                                distance: legLength,
                                geometry: legGeojson.geometry
                            }
                        ]
                    });
                    legCoordinates = [(0, cloneDeep_1.default)(legCoordinates[legCoordinates.length - 1])];
                }
            });
            return {
                waypoints: nodesAndWaypointsGeojsons.map((point) => point.geometry),
                routes: [
                    {
                        distance: lineLength,
                        duration: birdDistanceDuration,
                        legs
                    }
                ]
            };
        });
    }
    routeToMapResults(results) {
        return {
            tracepoints: results.waypoints,
            matchings: results.routes.map((route) => {
                return Object.assign({ confidence: 1 }, route);
            })
        };
    }
    mapMatch(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const routingResult = yield this.directRouting(params.points.features, params.defaultRunningSpeed, true);
            return this.routeToMapResults(routingResult);
        });
    }
    route(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const routingResult = yield this.directRouting(params.points.features, params.defaultRunningSpeed, true);
            return routingResult;
        });
    }
    tableFrom(_params) {
        // TODO: Implement using bird distances
        throw new Error('ManualRoutingService tableFrom Method not implemented.');
    }
    tableTo(_params) {
        // TODO: Implement using bird distances
        throw new Error('ManualRoutingService tableTo Method not implemented.');
    }
}
exports.default = ManualRoutingService;
//# sourceMappingURL=ManualRoutingService.js.map